import { Component, OnDestroy, OnInit } from '@angular/core';
import { forkJoin, map, Observable, of, Subscription } from 'rxjs';
import { DataInput, InfoDialogComponent }  from '@trivelope/triv-ui-tools-lib';
import { DocumentExchangeCategory, MyDEFile } from 'src/app/classes/document-exchange';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';
import { Member } from 'src/app/classes/member';
import { MemberService } from 'src/app/services/member.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';


@Component({
	selector: 'document-exchange-creation',
	templateUrl: './document-exchange-creation.component.html',
	styleUrls: [ './document-exchange-creation.component.css' ],
})
export class DocumentExchangeCreationComponent implements OnInit, OnDestroy {


	bLoading = true;
	bLoadingError = false;
	subscriptions = new Subscription();

	documentExchangeCategories: DocumentExchangeCategory[] = [];
	members: Member[] = [];

	bAdmin = false;

	creationFormGroup = new FormGroup( {
		member: new FormControl( [] ),
		category: new FormControl( "", Validators.required ),
		description: new FormControl( "", Validators.required ),
		dateStart: new FormControl( "" ),
		dateEnd: new FormControl( "" ),
	});

	fileDataInput = new DataInput();
	myFiles: MyDEFile[] = [];
	bUploading = false;
	bUploadError = false;
	static fileId = 0;
	totalSizeMB = 0;
	readonly MAX_TOTAL_SIZE_MB = 100;


	constructor(
		private documentExchangeService: DocumentExchangeService,
		private memberService: MemberService,
		private authenticationService: AuthenticationService,
		private matDialog: MatDialog,
		private router: Router
	) {
		this.fileDataInput.id = "fileUploadInput";
		this.fileDataInput.type = "file";
		this.fileDataInput.multipleFiles = true;
		this.fileDataInput.filesizeMaxMB = 30;
	}


	ngOnInit() {

		const obss: Observable<boolean>[] = [ of(true) ];

		this.bAdmin = this.authenticationService.isAdmin();
		if( this.bAdmin ) {
			obss.push( this.memberService.getAll().pipe(
				map( members => {
					if( members === null ) {
						this.bLoadingError = true;
						return false;
					}
					else {
						this.members = members;
						return true;
					}
				})
			) );
		}
		obss.push( this.documentExchangeService.getDocumentExchangeCategories().pipe(
			map( categories => {
				if( categories === null ) {
					this.bLoadingError = true;
					return false;
				}
				else {
					this.documentExchangeCategories = categories;
					return true;
				}
			})
		) );

		forkJoin( obss ).subscribe( results => {
			this.bLoading = false;
		});

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}



	onFilesChosen( files: File[] ) {

		console.log( "ONFILESCHOSEN", files )

		let nextTotalSizeMB = this.totalSizeMB;
		for( let file of files ) {
			nextTotalSizeMB += file.size / 1024 / 1024;
		}
		if( nextTotalSizeMB > this.MAX_TOTAL_SIZE_MB ) {
			this.matDialog.open( InfoDialogComponent, {
				data: { title: 'Datei fehlt', message: 'Die maximale Gesamtdateigröße beträgt ' + this.MAX_TOTAL_SIZE_MB + ' MB' }
			});
			return;
		}

		this.totalSizeMB += nextTotalSizeMB;

		for( let file of files ) {
			const myDEFile = new MyDEFile();
			myDEFile.id = "fileId_" + DocumentExchangeCreationComponent.fileId++;
			myDEFile.file = file;
			this.myFiles.push( myDEFile );
		}
		console.log( "ALL FILES", this.myFiles )

	}

	removeFile( myFile: MyDEFile ) {

		if( myFile.file?.size ) {
			this.totalSizeMB -= myFile.file.size / 1024 / 1024;
		}

		const index = this.myFiles.findIndex( f => myFile.id == f.id );
		if( index != -1 ) {
			this.myFiles.splice( index, 1 );
		}

	}

	upload() {

		if( !this.myFiles.length ) {
			this.matDialog.open( InfoDialogComponent, {
				data: { title: 'Datei fehlt', message: 'Es wird mindestens eine Datei benötigt' }
			});
			return;
		}

		const values = this.creationFormGroup.value;
		const description = values.description || "";
		const category = values.category || "";
		const memberIds = values.member || [];
		const files: File[] = [];
		for( const myF of this.myFiles ) {
			if( !myF.file ) continue;
			files.push( myF.file );
		}
		console.log( "UPLOAD", this.myFiles )

		this.bUploading = true;
		this.bUploadError = false;
		this.creationFormGroup.disable();
		this.documentExchangeService.uploadDocumentExchange( description, category, memberIds, files ).subscribe( b => {
			this.bUploading = false;
			this.creationFormGroup.enable();
			if( !b ) {
				this.bUploadError = true;
			}
			else {
				this.router.navigate( [ "/Austausch" ] );
			}
			console.log( "RESULT", b )
		});

	}

}


